"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = exports.HorizontalRule = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var HorizontalRule = _styledComponents.default.hr.withConfig({
  displayName: "HorizontalRule",
  componentId: "sc-17vlj0i-0"
})(["display:block;margin-top:", ";margin-bottom:", ";margin-left:0;margin-right:0;height:0;box-sizing:content-box;overflow:visible;background:none;border-top:2px solid #dee3e5;border-bottom:none;border-left:none;border-right:none;"], function (props) {
  return props.marginTop ? props.marginTop : "3.5rem";
}, function (props) {
  return props.marginBottom ? props.marginBottom : "3.5rem";
});

exports.HorizontalRule = HorizontalRule;
HorizontalRule.propTypes = {
  className: _propTypes.default.string
};
var _default = HorizontalRule;
exports.default = _default;